var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.attachment.comment)?_c('p',{staticClass:"lead pre-line"},[_vm._v(_vm._s(_vm.attachment.comment))]):_vm._e(),_vm._v(" "),(_vm.attachment.object_type)?_c('Details',{attrs:{"attachment":_vm.attachment}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }